import { atom } from "recoil";

export const isCalibrationChangedState = atom<boolean>({
  key: "isCalibrationChangedState",
  default: false, // 기본값: 변경 없음
});

export const calibrationRegistTriggerState = atom<boolean>({
  key: "calibrationRegistTriggerState",
  default: false, // 기본값: 트리거 비활성화
});

export const calibrationDeleteTriggerState = atom<number>({
  key: "calibrationDeleteTriggerState",
  default: 0,
});

export const calibrationDeleteModalState = atom<{
  isOpen: boolean;
  isVisible: boolean;
}>({
  key: "calibrationDeleteModalState",
  default: {
    isOpen: false,
    isVisible: false,
  },
});

export const calibrationCreateModalState = atom<{
  isOpen: boolean;
  isVisible: boolean;
}>({
  key: "calibrationCreateModalState",
  default: {
    isOpen: false,
    isVisible: false,
  },
});
